import React from "react";

import {
  usePlaygroundLocalMsg,
  type PlaygroundMsgValues,
} from "./usePlaygroundLocalMsg";

type PlaygroundLocalMsgProps = {
  defaultMessage: string;
  values?: PlaygroundMsgValues;
};

export const PlaygroundLocalMsg: React.FC<PlaygroundLocalMsgProps> = ({
  defaultMessage,
  values,
}) => {
  const message = usePlaygroundLocalMsg(defaultMessage, values);
  return <>{message}</>;
};
